export default __webpack_public_path__ + "static/importance-d7fbe6d7d574d014dc29b835b0d92242.jpg";